import { render, staticRenderFns } from "./Rule_Kang.vue?vue&type=template&id=3c0d77a2&scoped=true&"
import script from "./Rule_Kang.vue?vue&type=script&lang=js&"
export * from "./Rule_Kang.vue?vue&type=script&lang=js&"
import style0 from "./Rule_Kang.vue?vue&type=style&index=0&id=3c0d77a2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d77a2",
  null
  
)

export default component.exports